import React from "react";
import Button from "@components/Button/Button";
import { t } from "i18next";
import { canUserResumeResumption } from "../utils";

interface ResumptionVesselCallProps {
  vesselCallFlowData?: {
    status: string;
  };
  interruptionTaskStatus?: string;
  claimOwnerName?: string;
  openDrawer: (drawerName: string) => void;
  refetchVesselCall: () => void;
}

const LANG_BASE = "vessel-call.vessel-call-status-header";

const ResumptionVesselCall: React.FC<ResumptionVesselCallProps> = ({
  vesselCallFlowData,
  openDrawer,
  refetchVesselCall,
  interruptionTaskStatus,
  claimOwnerName,
}) => {
  if (!vesselCallFlowData) {
    return null;
  }

  const taskStatus = interruptionTaskStatus;
  const ownerName = claimOwnerName;
  const isActionAvailable =
    taskStatus != null && ownerName != null && canUserResumeResumption(taskStatus, ownerName);

  const handleResumeClick = () => {
    refetchVesselCall();
    openDrawer("resumeDrawer");
  };
  if (!isActionAvailable) return null;
  return (
    <Button
      testId="resume-vessel-call"
      variant="outlined"
      disabled={!isActionAvailable}
      onClick={handleResumeClick}
      className="whitespace-nowrap"
      label={<span className="normal-case font-medium">{t(`${LANG_BASE}.resume-button`)}</span>}
    />
  );
};

export default ResumptionVesselCall;
